import React from "react";
import './TraderBonus.css';
import SendQuestion from "../../00LayoutMain/TopMenu/SendQuestion/SendQuestion";
import LayoutMain from "../../00LayoutMain/LayoutMain";
import TextChange from "../../../../AdminPart/src/Elements/TextChange/TextChange";

    function TraderBonusSource (props) {
    function TextSource(info) {let InText = '*undefined';if (props.Adminka) {try {InText = JSON.parse(props.AllInformation[info.ArrIndex])[props.lang] ? JSON.parse(props.AllInformation[info.ArrIndex])[props.lang] : '*'+info.children}   catch (err) {InText = '*'+info.children}return <TextChange update={props.updateData} Text={InText} ArrIndex={info.ArrIndex} lang={props.lang} Adminka={true}/>
    } else {try {return <>{JSON.parse(props.PrerenderTexts[info.ArrIndex])[props.lang] ? JSON.parse(props.PrerenderTexts[info.ArrIndex])[props.lang] : '*'+info.children}</>}   catch (err) {return <>*{info.children}</>}}}

        return (
            <LayoutMain title={props.title} description={props.description} lang={props.lang}>
            <main className="TraderBonus StandartPage">
                <div className="StandartNOTitle"/>
                <div className="StandartWhitePart">
                    <div className="StandartWhitePartTitle">
                        <div className="StandartWhitePartTitleText">
                            <TextSource lang = {props.lang} ArrIndex= '008010'>Бонусная программа</TextSource>
                        </div>
                        <SendQuestion lang={props.lang}/>
                    </div>
                    <div className="TraderBonusBannerOutOut">
                        <div className="TraderBonusBannerOut">
                            <div className="TraderBonusBanner"/>
                        </div>
                    </div>
                    <div className="TraderBonusMainGrid">
                        <div className="TraderBonusMainGridMoney">
                            <div className="TraderBonusMainGridMoneyElement">
                                <div className="TraderBonusMainGridMoneyElementMoney">
                                    1/3<div className="TraderBonusMainGridMoneyElementMoneyIn">C </div>
                                </div>
                                <div className="TraderBonusMainGridMoneyElementDesc"><TextSource lang = {props.lang} ArrIndex= '008020'>За Forex</TextSource>

                                </div>
                            </div>
                            <div className="TraderBonusMainGridMoneyElement">
                                <div className="TraderBonusMainGridMoneyElementMoney">
                                    1/3 <div className="TraderBonusMainGridMoneyElementMoneyIn">C  </div>
                                </div>
                                <div className="TraderBonusMainGridMoneyElementDesc"><TextSource lang = {props.lang} ArrIndex= '008030'>За Crypto, Индексы</TextSource>

                                </div>
                            </div>
                            <div className="TraderBonusMainGridMoneyElement">
                                <div className="TraderBonusMainGridMoneyElementMoney">
                                    3 <div className="TraderBonusMainGridMoneyElementMoneyIn">$</div>
                                </div>
                                <div className="TraderBonusMainGridMoneyElementDesc"><TextSource lang = {props.lang} ArrIndex= '008040'>Лот Forex.Fixed</TextSource>

                                </div>
                            </div>
                            <div className="TraderBonusMainGridMoneyElement">
                                <div className="TraderBonusMainGridMoneyElementMoney">
                                    80<div className="TraderBonusMainGridMoneyElementMoneyIn">$</div>
                                </div>
                                <div className="TraderBonusMainGridMoneyElementDesc"><TextSource lang = {props.lang} ArrIndex= '008050'>Лот Forex.Big</TextSource>

                                </div>
                            </div>
                        </div>
                        <div className="TraderBonusMainGridText"><TextSource lang = {props.lang} ArrIndex= '008060'>
                            Бонусная программа компании FXBitcoin Forex позволяет клиенту дополнительно зарабатывать в процессе торговли. При внесении денежных средств на торговый счет вы получаете минимум 500% к депозиту, а в дни рождения и до 5000%!
                            Данный бонус является неким кредитом, то есть вы не можете снять эти средства,
                            а должны использовать его в торговых операциях. После того как вы закрыли определенное число сделок, вы можете вывести средства на депозит. Сумма, заработанная Вами, зависит от объема лотов и вида валютной - пары.
                            Совершив 1 лот, Вы уже получаете возможность вывода средств на Ваш депозит. Данная бонусная программа действует с 15 июня 2009 года и продолжает радовать своих клиентов. Она предоставляет уникальную возможность торговать при минимальном количестве средств.</TextSource>
                        </div>
                        <div className="TraderBonusMainGridWarning">
                            <div className="TraderBonusMainGridWarningText">
                                <div className="TraderBonusMainGridWarningTextTitle"><TextSource lang = {props.lang} ArrIndex= '008070'>Внимание!</TextSource></div>
                                <TextSource lang = {props.lang} ArrIndex= '008080'>
                                    При пополнении счета в получаете до 500% от суммы пополнения на ваш бонусный счет.
                                    Эта сумма не участвует в просадке и ее нельзя вывести — однако если вы открываете сделки — то вы можете перевести средства с бонусного счета на ваш депозит. Объем средств, который вы мжоете перевести на депозит (и далее вывести со счета) зависит от типа торговых инструментов.
                                    Для участия в бонусной программе просто пополните счет</TextSource>
                            </div>
                        </div>
                    </div>
                </div>
            </main>
            </LayoutMain>
        )
    }

export default TraderBonusSource